const assetOrder = [
  'GOLD',
  'BTC',
  'ETH',
  'DASH',
  'SILV',
];

export default assetOrder;
